import { useState } from "react";
import { IconButton, Badge, Tooltip } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import { useCart, useDialog } from "hooks";

export const NavbarCartButton = () => {
  const { cart } = useCart();
  const { openCheckout } = useDialog();
  const [hover, setHover] = useState(false);

  const totalItems = Object.values(cart.items || {}).reduce(
    (acc, qty) => acc + qty,
    0,
  );

  const hasItems = totalItems > 0;

  const tooltip = hasItems
    ? `${totalItems} item${totalItems !== 1 ? "s" : ""} in cart`
    : "Your cart is empty";

 const icon = hover ? (
  <ShoppingCartCheckoutIcon color="warning" />
 ) : (
  <ShoppingCartIcon color={hasItems ? "warning" : "inherit"} />
 );

  return (
    <Tooltip title={tooltip} arrow>
      <span>
        <IconButton
          onClick={openCheckout}
          size="small"
          color={hasItems ? "primary" : "default"}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <Badge
            badgeContent={hasItems ? totalItems : null}
            color="warning"
            max={9}
            >
                {icon}
          </Badge>
        </IconButton>
      </span>
    </Tooltip>
  );
};
